export default __webpack_public_path__ + "static/media/LINEA-Logo-tren-maya.cc54136a.svg";